export const menuData = [
  { title: 'Home', link: '/' },
  { title: 'About Us', link: '/about-us' },
  { title: 'Recent Projects', link: '/recent-projects' },
  { title: 'Energy Efficiency', link: '/energy-efficiency' },
  { title: 'Blog', link: '/blog' },
  { title: 'Contact Us', link: '/contact' },
];
